import React, { useState, useEffect } from "react"
import { Spinner, Button } from "reactstrap"
import axios from "axios"
import { connect } from "react-redux"
import { useWallet } from "../libs/useMetaMaskWallet"
import TradingCard from "../Components/TradingCard"
import {
    setLoading,
    setMoreItemsLoading,
    setTradingItems,
    addTradingItems,
    setTradingTokens,
    setLastEvaluatedKey
} from "../store/trading/tradingActions"
import MetamaskLogo from "../assets/images/metamask.png"
import { convertTradingTokenToNFTDetails } from "../utils"
import { setAllTokens } from "../store/common/commonActions"
import ConnectWallet from "../Components/ConnectWallet"
import BreadCrumb from "../Components/BreadCrumb"
import Select from "../Components/Select"
import { CustomSlider } from "../Components/Slider"

const SortItems = [
    {
        label: "Created",
        value: "inserted"
    },
    {
        label: "Listed",
        value: "updated"
    },
    {
        label: "Price",
        value: "price"
    }
    // {
    //   label: 'Purchased',
    //   value: 'Purchased'
    // }
]

const SortDirection = [
    {
        label: "Oldest First",
        value: "Oldest first"
    },
    {
        label: "Newest First",
        value: "Newest first"
    }
]

const CustomSliderThumbComponent = (props) => {
    const { children, ...other } = props
    return (
        <div {...other}>
            {children}
            <span>{props["aria-valuenow"]}</span>
        </div>
    )
}

const Trading = (props) => {
    const {
        loading,
        moreItemsLoading,
        items,
        tokens,
        lastEvaluatedKey,
        setLoading,
        setMoreItemsLoading,
        setTradingItems,
        setTradingTokens,
        setLastEvaluatedKey,
        setAllTokens
    } = props

    const wallet = useWallet()
    const tradingApi = "https://nft.idexo.io"

    const [selectedSortItem, setSelectedSortItem] = useState(SortItems[0])
    const [selectedSortDirection, setSelectedSortDirection] = useState(SortDirection[0])
    const [priceRange, setPriceRange] = useState([0, 99])
    const [filteredTokens, setFilteredTokens] = useState([])
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [search, setSearch] = useState("")
    const [searchOpen, isSearchOpen] = useState(false)

    useEffect(() => {
        const fetchNFT = async () => {
            const trading_tokens = []
            for (let i = 0; i < items.length; i++) {
                const item = convertTradingTokenToNFTDetails(items[i])
                if (item.source.includes("avalanche") && item.token_uri) {
                    const token_details = await axios.get(item.token_uri)
                    trading_tokens.push({
                        ...item,
                        details: token_details.data,
                        blockChain: "avalanche"
                    })
                } else if (item.source.includes("polygon") && item.token_uri) {
                    const token_details = await axios.get(item.token_uri)
                    trading_tokens.push({
                        ...item,
                        details: token_details.data,
                        blockChain: "polygon"
                    })
                }
            }
            setTradingTokens(trading_tokens)
            setAllTokens(trading_tokens)
        }
        if (items.length) {
            fetchNFT()
        }
    }, [items, items.length, setLoading, setTradingTokens, setAllTokens])

    useEffect(() => {
        if (!items.length) fetchItems(0, 99)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setIsConnectedToWallet(wallet.status === "connected")
    }, [wallet, wallet.status])

    useEffect(() => {
        if (selectedSortDirection.value === "Newest first") {
            tokens.sort(function (a, b) {
                return b[selectedSortItem.value] - a[selectedSortItem.value]
            })
        } else {
            tokens.sort(function (a, b) {
                return a[selectedSortItem.value] - b[selectedSortItem.value]
            })
        }
        setFilteredTokens(tokens)
    }, [selectedSortDirection, selectedSortItem, tokens, tokens.length])

    const handleChange = (event, newValue) => {
        setPriceRange(newValue)
    }

    const connectWallet = () => {}

    const setData = (data) => {
        if (data.error) {
            alert("Error: " + data.error)
        } else {
            if (data.data && data.data.Items) {
                setTradingItems(data.data.Items)
                if (data.data.LastEvaluatedKey) {
                    setLastEvaluatedKey(encodeURIComponent(JSON.stringify(data.data.LastEvaluatedKey)))
                } else {
                    setLastEvaluatedKey(false)
                }
            }
        }
    }

    const fetchItems = (min, max) => {
        let startKey = null
        if (lastEvaluatedKey) {
            startKey = lastEvaluatedKey
            setMoreItemsLoading(true)
        } else {
            setTradingTokens([])
            setAllTokens([])
            setTradingItems([])
            setLoading(true)
        }
        fetch(`${tradingApi}/?min=${min}&max=${max}&forward=true&limit=20&startkey=${startKey}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    return (
        <React.Fragment>
            <div className="content trading-page">
                <BreadCrumb items={["Trading"]} />
                <div className="header">
                    <Button color="primary" className="search-btn" onClick={() => isSearchOpen(!searchOpen)}>
                        <i className="bx bx-search" />
                    </Button>
                    {searchOpen ? (
                        <div className="search">
                            <div className="search-input">
                                <input
                                    id="searchInput"
                                    type="text"
                                    className="form-control"
                                    defaultValue={search}
                                    onKeyPress={(e) => setSearch(e.target.value)}
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="price-range">
                            <label>Price Range</label>
                            <div className="price-range-select">
                                <CustomSlider
                                    value={priceRange}
                                    onChange={handleChange}
                                    onChangeCommitted={() => fetchItems(priceRange[0], priceRange[1])}
                                    aria-labelledby="range-slider"
                                    max={500}
                                    ThumbComponent={CustomSliderThumbComponent}
                                />
                            </div>
                        </div>
                    )}
                    <div className="sort-by">
                        <label>Sort by</label>
                        <div className="sort-select">
                            <Select value={selectedSortItem} onChange={setSelectedSortItem} options={SortItems} isSearchable={false} />
                        </div>
                        <div className="sort-select">
                            <Select value={selectedSortDirection} onChange={setSelectedSortDirection} options={SortDirection} isSearchable={false} />
                        </div>
                    </div>
                </div>
                {loading && (
                    <div className="card-loading full-page">
                        <Spinner size="lg" color="primary" />
                    </div>
                )}
                {loading || filteredTokens.length ? (
                    <div className="card-list">
                        {!loading &&
                            filteredTokens.map((item, index) => (
                                <TradingCard
                                    data={item}
                                    key={index}
                                    buy={true}
                                    isConnectedToWallet={isConnectedToWallet}
                                    connectWallet={connectWallet}
                                />
                            ))}
                    </div>
                ) : (
                    <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                        <div className="metamask_logo">
                            <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                        </div>
                        <h1 className="mt-4">No NFT Token</h1>
                    </div>
                )}
                {filteredTokens.length ? (
                    !loading &&
                    lastEvaluatedKey && (
                        <div className="card-loading">
                            {moreItemsLoading ? (
                                <Spinner size="lg" color="primary" />
                            ) : (
                                <Button outline color="primary" size="lg" onClick={() => fetchItems(priceRange[0], priceRange[1])}>
                                    Load More
                                </Button>
                            )}
                        </div>
                    )
                ) : (
                    <></>
                )}
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    loading: state.tradingReducer.loading,
    moreItemsLoading: state.tradingReducer.moreItemsLoading,
    items: state.tradingReducer.items,
    tokens: state.tradingReducer.tokens,
    lastEvaluatedKey: state.tradingReducer.lastEvaluatedKey
})

const mapDispatchToProps = {
    setLoading,
    setMoreItemsLoading,
    setTradingItems,
    addTradingItems,
    setTradingTokens,
    setLastEvaluatedKey,
    setAllTokens
}

export default connect(mapStateToProps, mapDispatchToProps)(Trading)
